import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { Pagination } from 'react-bootstrap';
import { MAX_SEARCH_RESULTS } from '../../../resources/constants/api';
import { SEARCH_RESULT_PAGE_SIZES } from '../../../resources/constants/searches';
import { CURRENT_PAGE_ITEM_ID } from '../../../resources/constants/ui';
import { Spinner } from '../../../resources/media/Spinner';

export class Pager extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showSpinner: false
		}
		this.changePageSize = this.changePageSize.bind(this);
		this.getPageItems = this.getPageItems.bind(this);
		this.loadPage = this.loadPage.bind(this);
	}

	async changePageSize(newPageSize) {
		if (!this.state.showSpinner) {
			this.setState({showSpinner: true, batchSize: newPageSize});
			await this.props.setBatchSize(newPageSize);
			this.setState(
				{showSpinner: false},
				() => this.loadPage(1)
			);
		}
	}

	async loadPage(pageNum) {
		if (!this.state.showSpinner) {
			this.setState({showSpinner: true});
			await this.props.getDataForPage(pageNum);
			this.setState({showSpinner: false});
		}
	}

	getPageItems({startIndex, totalCount, batchSize, keyVal}) {
		const pageItems = [];
		const currentPage = Math.trunc(startIndex / batchSize) + 1;
		const totalAvailable = Math.min(totalCount, MAX_SEARCH_RESULTS);
		const totalWithMaxString = totalCount >= MAX_SEARCH_RESULTS
			? `${MAX_SEARCH_RESULTS.toLocaleString()}+`
			: totalCount.toLocaleString();
		const lastIndex = Math.min(totalCount, startIndex + batchSize - 1);
		const countString = startIndex === lastIndex
			? <span>
				<strong>{startIndex.toLocaleString()}</strong>{` of ${totalWithMaxString}`}
			</span>
			: <span>
				<strong>
					{`${startIndex.toLocaleString()}-${lastIndex.toLocaleString()}`}
				</strong>{` of ${totalWithMaxString}`}
			</span>;
		var lastPage = Math.trunc(
			totalAvailable % batchSize > 0
				? totalAvailable / batchSize + 1
				: totalAvailable / batchSize
		);
		var totalPages = MAX_SEARCH_RESULTS / batchSize;
		if(lastPage > totalPages) {
			lastPage = Math.trunc(MAX_SEARCH_RESULTS % batchSize) > 0
				? totalPages + 1
				: totalPages;
		}
		const isFirstPage = startIndex === 1;
		const isLastPage = currentPage === lastPage;
		
		pageItems.push(
			<li className={isFirstPage ? "page-item disabled" : "page-item"} title="First Page" key={`${keyVal}-first`}>
				{
					isFirstPage ?
					<span className="page-link navigation-item" disabled>
						<span aria-hidden="true">«</span>
						<span className="sr-only">First</span>
					</span> :
					<button
						className="page-link navigation-item"
						onClick={() => this.loadPage(1)}
						type="button"
					>
						<span aria-hidden="true">«</span>
						<span className="sr-only">Next</span>
					</button>
				}
			</li>
		);
		pageItems.push(
			<li className={isFirstPage ? "page-item disabled" : "page-item"} title="Previous Page" key={`${keyVal}-prev`}>
				{
					isFirstPage ?
					<span className="page-link navigation-item" disabled>
						<span aria-hidden="true">‹</span>
						<span className="sr-only">Previous</span>
					</span> :
					<button
						className="page-link navigation-item"
						onClick={() => this.loadPage(currentPage - 1)}
						type="button"
					>
						<span aria-hidden="true">‹</span>
						<span className="sr-only">Previous</span>
					</button>
				}
			</li>
		);
		pageItems.push(
			<div
				className="current-page-box vertical-center-flex"
				key={`${keyVal}-currentpage`}
				id={CURRENT_PAGE_ITEM_ID}
			>
				{countString}
			</div>
		);
		pageItems.push(
			<li className={isLastPage ? "page-item disabled" : "page-item"} title="Next Page" key={`${keyVal}-next`}>
				{
					isLastPage ?
					<span className="page-link navigation-item" disabled>
						<span aria-hidden="true">›</span>
						<span className="sr-only">Next</span>
					</span> :
					<button
						className="page-link navigation-item"
						onClick={() => this.loadPage(currentPage + 1)}
						type="button"
					>
						<span aria-hidden="true">›</span>
						<span className="sr-only">Next</span>
					</button>
				}
			</li>
		);
		pageItems.push(
			<li className={isLastPage ? "page-item disabled" : "page-item"} title="Last Page" key={`${keyVal}-last`}>
				{
					isLastPage ?
					<span className="page-link navigation-item" disabled>
						<span aria-hidden="true">»</span>
						<span className="sr-only">Last</span>
					</span> :
					<button
						className="page-link navigation-item"
						onClick={() => this.loadPage(lastPage)}
						type="button"
					>
						<span aria-hidden="true">»</span>
						<span className="sr-only">Last</span>
					</button>
				}
			</li>
		);
		/*pageItems.push(
			<Pagination.First
				onClick={() => this.loadPage(1)}
				disabled={isFirstPage}
				key={`${keyVal}-first`}
			/>
		);
		pageItems.push(
			<Pagination.Prev
				onClick={() => this.loadPage(currentPage - 1)}
				disabled={isFirstPage}
				key={`${keyVal}-prev`}
			/>
		);
		pageItems.push(
			<div
				className="current-page-box vertical-center-flex"
				key={`${keyVal}-currentpage`}
				id={CURRENT_PAGE_ITEM_ID}
			>
				{countString}
			</div>
		);
		pageItems.push(
			<Pagination.Next
				onClick={() => this.loadPage(currentPage + 1)}
				disabled={isLastPage}
				key={`${keyVal}-next`}
			/>
		);
		pageItems.push(
			<Pagination.Last
				onClick={() => this.loadPage(lastPage)}
				disabled={isLastPage}
				key={`${keyVal}-last`}
			/>
		);*/
		return pageItems;
	}

	render() {
		if (this.props.totalCount > 0) {
			return (
				<React.Fragment>
					<div className="relative-box">
						<div className="">
							<Row>
								<Col sm={3}>
									<div className="pager-loader">
										{this.state.showSpinner ? <Spinner/> : null}
									</div>
								</Col>
								<Col sm={6}>
									<div className="auto-margin">
										<Pagination
											className={"stb-pager"}
											key={this.props.keyVal || "pager"}
										>
											{this.getPageItems(this.props)}
										</Pagination>
									</div>
								</Col>
								<Col sm={3}>
									{
										this.props.showPageSize
										? <Row className="vert-center">
											<Col sm={8}>
												<Form.Label
													size={1}
													className="pad-left"
													for="batchSize"
												><strong>Records per page</strong></Form.Label>
											</Col>
											<Col className="pad-right-10" sm={4}>
												<Form.Control
													as="select"
													id="batchSize"
													name="batchSize"
													className="right-corners--sharp"
													value={this.props.batchSize || 50}
													onChange={(e) => this.changePageSize(e.target.value)}
												>
													{
														SEARCH_RESULT_PAGE_SIZES.map((value, idx) => {
															return (
																<option
																	key={`${idx}-${value}`}
																	selected={this.props.batchSize === value}
																>
																	{value}
																</option>
															);
														})
													}
												</Form.Control>
											</Col>
										</Row>
										: <></>
									}
								</Col>
							</Row>
						</div>
					</div>
				</React.Fragment>
			);
		} else {
			return null;
		}
	}
}